import { _mock } from './_mock';

// ----------------------------------------------------------------------

export const _carouselsMembers = [...Array(6)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.fullName(index),
  // role: _mock.role(index),
}));

// ----------------------------------------------------------------------

export const _faqs = [...Array(5)].map((_, index) => ({
  id: _mock.id(index),
  value: `panel${index + 1}`,
  heading: _mock.heading(index),
  detail: _mock.description(index),
}));

export const _mapContact = [
  {
    latlng: [12.9105, 77.6239],
    address: _mock.fullAddress(1),
    phoneNumber: _mock.phoneNumber(1),
  },
];

// ----------------------------------------------------------------------

export const _socials = [
  {
    name: 'Whatsapp',
    icon: 'simple-icons:whatsapp',
    color: '#25D366',
    link: 'https://wa.me/+91 78 6935 1845',
  },
  {
    name: 'Instagram',
    icon: 'simple-icons:instagram',
    color: '#E02D69',
    link: 'https://www.instagram.com/satyendrasingh_',
  },
  {
    name: 'Twitter',
    icon: 'simple-icons:twitter',
    color: '#00AAEC',
    link: 'https://twitter.com/satyendraintech',
  },
  {
    name: 'Linkedin',
    icon: 'simple-icons:linkedin',
    color: '#007EBB',
    link: 'https://www.linkedin.com/in/satyendraintech',
  },
  {
    name: 'FaceBook',
    icon: 'simple-icons:facebook',
    color: '#1877F2',
    link: 'https://github.com/satyendraintech',
  },
];
export const _socialsShare = [
  {
    name: 'Whatsapp',
    icon: 'simple-icons:whatsapp',
    color: '#25D366',
    link: 'https://wa.me',
  },
  {
    name: 'Instagram',
    icon: 'simple-icons:instagram',
    color: '#E02D69',
    link: 'https://www.instagram.com',
  },
  {
    name: 'Twitter',
    icon: 'simple-icons:twitter',
    color: '#00AAEC',
    link: 'https://twitter.com',
  },
  {
    name: 'Linkedin',
    icon: 'simple-icons:linkedin',
    color: '#007EBB',
    link: 'https://www.linkedin.com',
  },
  {
    name: 'FaceBook',
    icon: 'simple-icons:facebook',
    color: '#1877F2',
    link: 'https://www.facebook.com',
  },
  {
    name: 'Pinterest',
    icon: 'simple-icons:pinterest',
    color: '#E60023',
    link: 'https://www.pinterest.com',
  },
];

// ----------------------------------------------------------------------

export const _homePlans = [...Array(3)].map((_, index) => ({
  license: ['UX Design', 'React Developer', 'Backend Developer'][index],
  commons: [
    'Develop interactive user interfaces using React.js',
    'Collaborate with designers and backend developers for seamless integration',
    'Optimize web applications for maximum speed and scalability ',
    'Write clean, maintainable, and well-documented code   ',
    'Conduct code reviews and provide constructive feedback',
    'Stay updated with industry trends and emerging technologies ',
  ],
}));

export const _testimonials = [
  {
    name: _mock.fullName(1),
    postedDate: _mock.time(2023, 8, 10),
    ratingNumber: 5,
    content: `Satyendra consistently delivers clean, maintainable UI solutions. His ability to understand requirements and translate them into scalable frontend components made our project smooth and reliable.`,
  },
  {
    name: _mock.fullName(2),
    postedDate: _mock.time(2024, 2, 18),
    ratingNumber: 5,
    content: `The TitanEx portal exceeded our expectations. The UI is fast, intuitive, and well-structured. Great attention to detail and timely delivery. Thanks, Satya!`,
  },
  {
    name: _mock.fullName(3),
    postedDate: _mock.time(2022, 5, 27),
    ratingNumber: 4,
    content: `Satyendra explains complex technical concepts clearly and always proposes practical solutions. Working with him made frontend decisions much easier for the team.`,
  },
  {
    name: _mock.fullName(4),
    postedDate: _mock.time(2023, 11, 19),
    ratingNumber: 5,
    content: `Very supportive and professional to work with. Always willing to help teammates and ensure tasks are completed with quality.`,
  },
  {
    name: _mock.fullName(5),
    postedDate: _mock.time(2024, 8, 17),
    ratingNumber: 5,
    content: `His frontend best practices and performance optimizations significantly improved our development workflow and overall productivity.`,
  },
  {
    name: _mock.fullName(6),
    postedDate: _mock.time(2022, 5, 10),
    ratingNumber: 4,
    content: `Satyendra’s technical content and practical guidance helped me improve my UI development skills and understand real-world frontend challenges better.`,
  },
];
